import { Link } from '@mui/material';
import ConvergenceZoneMethodology from '../ConvergenceZoneMethodology';
// export const YEARS = ['2015', '2020', '2025','2030','2035','2040','2045', '2050','2055','2060'];

// export function getYearsMarks() {
//     const marks = {};
//     YEARS.forEach((y, i) => {
//         marks[i] = y;
//     });
//     return marks;
// }

export const YEARS = ['2015', '2020', '2025','2030','2035','2040','2045', '2050','2055','2060'];

export function getYearsMarks() {
    // Use .map() to transform the YEARS array into the required format
    const marks = YEARS.map((year, index) => ({
        value: index, // The index corresponds to the slider value
        label: year   // The year string is the label
    }));
    return marks; // Return the array of objects
}



export const defaultFormatter = (value) => YEARS[value];

export const defaultToolTip = {
    open: true,
    formatter:  defaultFormatter
}



export const waveFormatter = (value) => waveYEARS[value];

export const waveToolTip = {
    open: true,
    formatter: waveFormatter
}

export const waveYEARS = ['2023-01-01', '2023-01-02', '2023-01-03', '2023-01-04', '2023-01-05', '2023-01-06', '2023-01-07']
//  ,'2023-01-08', '2023-01-09', '2023-01-10', '2023-01-11', '2023-01-12', '2023-01-13', '2023-01-14', '2023-01-15', '2023-01-16', '2023-01-17', '2023-01-18', '2023-01-19', '2023-01-20', '2023-01-21', '2023-01-22', '2023-01-23', '2023-01-24', '2023-01-25', '2023-01-26', '2023-01-27', '2023-01-28', '2023-01-29', '2023-01-30','2023-01-31'];
// export function getWaveYearsMarks() {
//     const marks = {};
//     waveYEARS.forEach((y, i) => {
//         marks[i] = y;
//     });
//     return marks;
// }

export function getWaveYearsMarks() {
    // Iterate over the waveYEARS array and transform it directly
    // into the required array format: [{ value: number, label: string }]
    const marksArray = waveYEARS.map((year, index) => ({
        value: index,       // The index becomes the 'value' for the slider
        label: String(year) // The year becomes the 'label'
    }));

    return marksArray;
}

export const createMarksGenerator = (forecastDates) => {
  
  // It returns a NEW function. This is the magic.
  return () => {
    // This returned function "remembers" the forecastKey from its parent.
    // This is called a "closure".
    // const dateArray = allForecasts[forecastKey] || [];
    
    return forecastDates.map((date, index) => ({
      value: index,
      label: String(date)
    }));
  };
};





export const tosProjectionDict = {0: '2015', 1: '2016', 2: '2017', 3: '2018', 4: '2019', 5: '2020', 6: '2021', 7: '2022', 8: '2023', 9: '2024', 10: '2025', 11: '2026', 12: '2027', 13: '2028', 14: '2029', 15: '2030', 16: '2031', 17: '2032', 18: '2033', 19: '2034', 20: '2035', 21: '2036', 22: '2037', 23: '2038', 24: '2039', 25: '2040', 26: '2041', 27: '2042', 28: '2043', 29: '2044', 30: '2045', 31: '2046', 32: '2047', 33: '2048', 34: '2049', 35: '2050', 36: '2051', 37: '2052', 38: '2053', 39: '2054', 40: '2055', 41: '2056', 42: '2057', 43: '2058', 44: '2059', 45: '2060', 46: '2061', 47: '2062', 48: '2063', 49: '2064', 50: '2065', 51: '2066', 52: '2067', 53: '2068', 54: '2069', 55: '2070', 56: '2071', 57: '2072', 58: '2073', 59: '2074', 60: '2075', 61: '2076', 62: '2077', 63: '2078', 64: '2079', 65: '2080', 66: '2081', 67: '2082', 68: '2083', 69: '2084', 70: '2085', 71: '2086', 72: '2087', 73: '2088', 74: '2089', 75: '2090', 76: '2091', 77: '2092', 78: '2093', 79: '2094', 80: '2095', 81: '2096', 82: '2097', 83: '2098', 84: '2099', 85: '2100'}


export const tosProjectionMonthlyDict = {};
let year = 2015;
let month = 1;

for (let i = 0; i < 1032; i++) { // 86 years * 12 months = 1032 entries
    const formattedMonth = month.toString().padStart(2, '0');
    tosProjectionMonthlyDict[i] = `${year}-${formattedMonth}`;
    month++;
    if (month > 12) {
        month = 1;
        year++;
    }
}
// export const tosProjectionMonthlyDict = 

export const tosProjectionMonths = Object.values(tosProjectionMonthlyDict);

export const tosOverDict = {0: '2040', 1: '2041', 2: '2042', 3: '2043', 4: '2044', 5: '2045', 6: '2046', 7: '2047', 8: '2048', 9: '2049', 10: '2050', 11: '2051', 12: '2052', 13: '2053', 14: '2054', 15: '2055', 16: '2056', 17: '2057', 18: '2058', 19: '2059', 20: '2060', 21: '2061', 22: '2062', 23: '2063', 24: '2064', 25: '2065', 26: '2066', 27: '2067', 28: '2068', 29: '2069', 30: '2070', 31: '2071', 32: '2072', 33: '2073', 34: '2074', 35: '2075', 36: '2076', 37: '2077', 38: '2078', 39: '2079', 40: '2080', 41: '2081', 42: '2082', 43: '2083', 44: '2084', 45: '2085', 46: '2086', 47: '2087', 48: '2088', 49: '2089', 50: '2090', 51: '2091', 52: '2092', 53: '2093', 54: '2094', 55: '2095', 56: '2096', 57: '2097', 58: '2098', 59: '2099', 60: '2100'}


export const tosHistoricFormatter = (value) => tosHistoricYears[value];

export const tosHistoricToolTip = {
    open: true,
    formatter: tosHistoricFormatter
}

export const tosHistoricYears = ['1850',
'1851',
'1852',
'1853',
'1854',
'1855',
'1856',
'1857',
'1858',
'1859',
'1860',
'1861',
'1862',
'1863',
'1864',
'1865',
'1866',
'1867',
'1868',
'1869',
'1870',
'1871',
'1872',
'1873',
'1874',
'1875',
'1876',
'1877',
'1878',
'1879',
'1880',
'1881',
'1882',
'1883',
'1884',
'1885',
'1886',
'1887',
'1888',
'1889',
'1890',
'1891',
'1892',
'1893',
'1894',
'1895',
'1896',
'1897',
'1898',
'1899',
'1900',
'1901',
'1902',
'1903',
'1904',
'1905',
'1906',
'1907',
'1908',
'1909',
'1910',
'1911',
'1912',
'1913',
'1914',
'1915',
'1916',
'1917',
'1918',
'1919',
'1920',
'1921',
'1922',
'1923',
'1924',
'1925',
'1926',
'1927',
'1928',
'1929',
'1930',
'1931',
'1932',
'1933',
'1934',
'1935',
'1936',
'1937',
'1938',
'1939',
'1940',
'1941',
'1942',
'1943',
'1944',
'1945',
'1946',
'1947',
'1948',
'1949',
'1950',
'1951',
'1952',
'1953',
'1954',
'1955',
'1956',
'1957',
'1958',
'1959',
'1960',
'1961',
'1962',
'1963',
'1964',
'1965',
'1966',
'1967',
'1968',
'1969',
'1970',
'1971',
'1972',
'1973',
'1974',
'1975',
'1976',
'1977',
'1978',
'1979',
'1980',
'1981',
'1982',
'1983',
'1984',
'1985',
'1986',
'1987',
'1988',
'1989',
'1990',
'1991',
'1992',
'1993',
'1994',
'1995',
'1996',
'1997',
'1998',
'1999',
'2000',
'2001',
'2002',
'2003',
'2004',
'2005',
'2006',
'2007',
'2008',
'2009',
'2010',
'2011',
'2012',
'2013',
'2014']


export function gettosHistoricMarks() {
    // const marks = {};
    // tosHistoricYears.forEach((y, i) => {
    //     marks[i] = y;
    // });

    const marks = {0:"1850", 164:"2014"};
    return marks;
}

export function gettosProjectionMonthlyMarks() {
    const marks = {};
    
    // Assuming `tosHistoricYears` is an array and `tosProjectionMonthlyDict` is your object
    // If you want the last index, use Object.keys(tosProjectionMonthlyDict).length - 1
    marks[0] = "2015-01-16";
    marks[Object.keys(tosProjectionMonthlyDict).length - 1] = "2100-12-16";
    
    return marks;
}

export const tosProjectionMonthlyFormatter = (value) => tosProjectionMonths[value];

export const tosProjectionMonthlyToolTip = {
    open: true,
    formatter: tosProjectionMonthlyFormatter
}


export const tosSSP126Years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055', '2056', '2057', '2058', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2078', '2079', '2080', '2081', '2082', '2083', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2091', '2092', '2093', '2094', '2095', '2096', '2097', '2098', '2099', '2100']

export const tosSSP126Formatter = (value) => tosSSP126Years[value];

export const tosSSP126ToolTip = {
    open: true,
    formatter: tosSSP126Formatter
}

// export function gettosSSP126Marks() {

//     const marks = {0:"2015", 85:"2100"};
//     return marks;
// }

export function gettosSSP126Marks() {
    // Original object defining the marks
    const marksObject = { 0: "2015", 85: "2100" };

    // Convert the object into the required array format
    const marksArray = Object.entries(marksObject).map(([key, label]) => ({
        value: Number(key),
        label: String(label)
    }));

    return marksArray;
}


export const tosSSP434Years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055', '2056', '2057', '2058', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2078', '2079', '2080', '2081', '2082', '2083', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2091', '2092', '2093', '2094', '2095', '2096', '2097', '2098', '2099', '2100']

export const tosSSP434Formatter = (value) => tosSSP434Years[value];

export const tosSSP434ToolTip = {
    open: true,
    formatter: tosSSP434Formatter
}

export function gettosSSP434Marks() {

    const marks = {0:"2015", 85:"2100"};
    return marks;
}


export const tosSSP460Years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055', '2056', '2057', '2058', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2078', '2079', '2080', '2081', '2082', '2083', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2091', '2092', '2093', '2094', '2095', '2096', '2097', '2098', '2099', '2100']

export const tosSSP460Formatter = (value) => tosSSP460Years[value];

export const tosSSP460ToolTip = {
    open: true,
    formatter: tosSSP460Formatter
}

export function gettosSSP460Marks() {

    const marks = {0:"2015", 85:"2100"};
    return marks;
}


export const tosSSP534OVERYears = ['2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055', '2056', '2057', '2058', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2078', '2079', '2080', '2081', '2082', '2083', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2091', '2092', '2093', '2094', '2095', '2096', '2097', '2098', '2099', '2100']
export const tosSSP534OVERFormatter = (value) => tosSSP534OVERYears[value];

export const tosSSP534OVERToolTip = {
    open: true,
    formatter: tosSSP534OVERFormatter
}

export function gettosSSP534OVERMarks() {

    const marks = {0:"2040", 60:"2100"};
    return marks;
}

export const tosSSP585Years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2051', '2052', '2053', '2054', '2055', '2056', '2057', '2058', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2078', '2079', '2080', '2081', '2082', '2083', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2091', '2092', '2093', '2094', '2095', '2096', '2097', '2098', '2099', '2100']

export const tosSSP585Formatter = (value) => tosSSP585Years[value];

export const tosSSP585ToolTip = {
    open: true,
    formatter: tosSSP585Formatter
}

export function gettosSSP585Marks() {

    const marks = {0:"2015", 85:"2100"};
    return marks;
}





// Marine Heat Wave slider dates (auto-updated by marine-heat-waves.ipynb)
// Canonical source: portal jsonFiles/mhw/mhw_{monthly|seasonal|decadal}_gridded/*.fgb

export const mhwMonthlyDates = ['1985-01',
'1985-02',
'1985-03',
'1985-04',
'1985-05',
'1985-06',
'1985-07',
'1985-08',
'1985-09',
'1985-10',
'1985-11',
'1985-12',
'1986-01',
'1986-02',
'1986-03',
'1986-04',
'1986-05',
'1986-06',
'1986-07',
'1986-08',
'1986-09',
'1986-10',
'1986-11',
'1986-12',
'1987-01',
'1987-02',
'1987-03',
'1987-04',
'1987-05',
'1987-06',
'1987-07',
'1987-08',
'1987-09',
'1987-10',
'1987-11',
'1987-12',
'1988-01',
'1988-02',
'1988-03',
'1988-04',
'1988-05',
'1988-06',
'1988-07',
'1988-08',
'1988-09',
'1988-10',
'1988-11',
'1988-12',
'1989-01',
'1989-02',
'1989-03',
'1989-04',
'1989-05',
'1989-06',
'1989-07',
'1989-08',
'1989-09',
'1989-10',
'1989-11',
'1989-12',
'1990-01',
'1990-02',
'1990-03',
'1990-04',
'1990-05',
'1990-06',
'1990-07',
'1990-08',
'1990-09',
'1990-10',
'1990-11',
'1990-12',
'1991-01',
'1991-02',
'1991-03',
'1991-04',
'1991-05',
'1991-06',
'1991-07',
'1991-08',
'1991-09',
'1991-10',
'1991-11',
'1991-12',
'1992-01',
'1992-02',
'1992-03',
'1992-04',
'1992-05',
'1992-06',
'1992-07',
'1992-08',
'1992-09',
'1992-10',
'1992-11',
'1992-12',
'1993-01',
'1993-02',
'1993-03',
'1993-04',
'1993-05',
'1993-06',
'1993-07',
'1993-08',
'1993-09',
'1993-10',
'1993-11',
'1993-12',
'1994-01',
'1994-02',
'1994-03',
'1994-04',
'1994-05',
'1994-06',
'1994-07',
'1994-08',
'1994-09',
'1994-10',
'1994-11',
'1994-12',
'1995-01',
'1995-02',
'1995-03',
'1995-04',
'1995-05',
'1995-06',
'1995-07',
'1995-08',
'1995-09',
'1995-10',
'1995-11',
'1995-12',
'1996-01',
'1996-02',
'1996-03',
'1996-04',
'1996-05',
'1996-06',
'1996-07',
'1996-08',
'1996-09',
'1996-10',
'1996-11',
'1996-12',
'1997-01',
'1997-02',
'1997-03',
'1997-04',
'1997-05',
'1997-06',
'1997-07',
'1997-08',
'1997-09',
'1997-10',
'1997-11',
'1997-12',
'1998-01',
'1998-02',
'1998-03',
'1998-04',
'1998-05',
'1998-06',
'1998-07',
'1998-08',
'1998-09',
'1998-10',
'1998-11',
'1998-12',
'1999-01',
'1999-02',
'1999-03',
'1999-04',
'1999-05',
'1999-06',
'1999-07',
'1999-08',
'1999-09',
'1999-10',
'1999-11',
'1999-12',
'2000-01',
'2000-02',
'2000-03',
'2000-04',
'2000-05',
'2000-06',
'2000-07',
'2000-08',
'2000-09',
'2000-10',
'2000-11',
'2000-12',
'2001-01',
'2001-02',
'2001-03',
'2001-04',
'2001-05',
'2001-06',
'2001-07',
'2001-08',
'2001-09',
'2001-10',
'2001-11',
'2001-12',
'2002-01',
'2002-02',
'2002-03',
'2002-04',
'2002-05',
'2002-06',
'2002-07',
'2002-08',
'2002-09',
'2002-10',
'2002-11',
'2002-12',
'2003-01',
'2003-02',
'2003-03',
'2003-04',
'2003-05',
'2003-06',
'2003-07',
'2003-08',
'2003-09',
'2003-10',
'2003-11',
'2003-12',
'2004-01',
'2004-02',
'2004-03',
'2004-04',
'2004-05',
'2004-06',
'2004-07',
'2004-08',
'2004-09',
'2004-10',
'2004-11',
'2004-12',
'2005-01',
'2005-02',
'2005-03',
'2005-04',
'2005-05',
'2005-06',
'2005-07',
'2005-08',
'2005-09',
'2005-10',
'2005-11',
'2005-12',
'2006-01',
'2006-02',
'2006-03',
'2006-04',
'2006-05',
'2006-06',
'2006-07',
'2006-08',
'2006-09',
'2006-10',
'2006-11',
'2006-12',
'2007-01',
'2007-02',
'2007-03',
'2007-04',
'2007-05',
'2007-06',
'2007-07',
'2007-08',
'2007-09',
'2007-10',
'2007-11',
'2007-12',
'2008-01',
'2008-02',
'2008-03',
'2008-04',
'2008-05',
'2008-06',
'2008-07',
'2008-08',
'2008-09',
'2008-10',
'2008-11',
'2008-12',
'2009-01',
'2009-02',
'2009-03',
'2009-04',
'2009-05',
'2009-06',
'2009-07',
'2009-08',
'2009-09',
'2009-10',
'2009-11',
'2009-12',
'2010-01',
'2010-02',
'2010-03',
'2010-04',
'2010-05',
'2010-06',
'2010-07',
'2010-08',
'2010-09',
'2010-10',
'2010-11',
'2010-12',
'2011-01',
'2011-02',
'2011-03',
'2011-04',
'2011-05',
'2011-06',
'2011-07',
'2011-08',
'2011-09',
'2011-10',
'2011-11',
'2011-12',
'2012-01',
'2012-02',
'2012-03',
'2012-04',
'2012-05',
'2012-06',
'2012-07',
'2012-08',
'2012-09',
'2012-10',
'2012-11',
'2012-12',
'2013-01',
'2013-02',
'2013-03',
'2013-04',
'2013-05',
'2013-06',
'2013-07',
'2013-08',
'2013-09',
'2013-10',
'2013-11',
'2013-12',
'2014-01',
'2014-02',
'2014-03',
'2014-04',
'2014-05',
'2014-06',
'2014-07',
'2014-08',
'2014-09',
'2014-10',
'2014-11',
'2014-12',
'2015-01',
'2015-02',
'2015-03',
'2015-04',
'2015-05',
'2015-06',
'2015-07',
'2015-08',
'2015-09',
'2015-10',
'2015-11',
'2015-12',
'2016-01',
'2016-02',
'2016-03',
'2016-04',
'2016-05',
'2016-06',
'2016-07',
'2016-08',
'2016-09',
'2016-10',
'2016-11',
'2016-12',
'2017-01',
'2017-02',
'2017-03',
'2017-04',
'2017-05',
'2017-06',
'2017-07',
'2017-08',
'2017-09',
'2017-10',
'2017-11',
'2017-12',
'2018-01',
'2018-02',
'2018-03',
'2018-04',
'2018-05',
'2018-06',
'2018-07',
'2018-08',
'2018-09',
'2018-10',
'2018-11',
'2018-12',
'2019-01',
'2019-02',
'2019-03',
'2019-04',
'2019-05',
'2019-06',
'2019-07',
'2019-08',
'2019-09',
'2019-10',
'2019-11',
'2019-12',
'2020-01',
'2020-02',
'2020-03',
'2020-04',
'2020-05',
'2020-06',
'2020-07',
'2020-08',
'2020-09',
'2020-10',
'2020-11',
'2020-12',
'2021-01',
'2021-02',
'2021-03',
'2021-04',
'2021-05',
'2021-06',
'2021-07',
'2021-08',
'2021-09',
'2021-10',
'2021-11',
'2021-12',
'2022-01',
'2022-02',
'2022-03',
'2022-04',
'2022-05',
'2022-06',
'2022-07',
'2022-08',
'2022-09',
'2022-10',
'2022-11',
'2022-12',
'2023-01',
'2023-02',
'2023-03',
'2023-04',
'2023-05',
'2023-06',
'2023-07',
'2023-08',
'2023-09',
'2023-10',
'2023-11',
'2023-12',
'2024-01',
'2024-02',
'2024-03',
'2024-04',
'2024-05',
'2024-06',
'2024-07',
'2024-08',
'2024-09',
'2024-10',
'2024-11',
'2024-12',
'2025-01',
'2025-02',
'2025-03',
'2025-04',
'2025-05',
'2025-06',
'2025-07',
'2025-08',
'2025-09',
'2025-10',
'2025-11',
'2025-12',
'2026-01',
'2026-02',
'2026-03',
'2026-04',
'2026-05',
'2026-06',
'2026-07']

export const mhwSeasonalDates = ['1985-Q1',
'1985-Q2',
'1985-Q3',
'1985-Q4',
'1986-Q1',
'1986-Q2',
'1986-Q3',
'1986-Q4',
'1987-Q1',
'1987-Q2',
'1987-Q3',
'1987-Q4',
'1988-Q1',
'1988-Q2',
'1988-Q3',
'1988-Q4',
'1989-Q1',
'1989-Q2',
'1989-Q3',
'1989-Q4',
'1990-Q1',
'1990-Q2',
'1990-Q3',
'1990-Q4',
'1991-Q1',
'1991-Q2',
'1991-Q3',
'1991-Q4',
'1992-Q1',
'1992-Q2',
'1992-Q3',
'1992-Q4',
'1993-Q1',
'1993-Q2',
'1993-Q3',
'1993-Q4',
'1994-Q1',
'1994-Q2',
'1994-Q3',
'1994-Q4',
'1995-Q1',
'1995-Q2',
'1995-Q3',
'1995-Q4',
'1996-Q1',
'1996-Q2',
'1996-Q3',
'1996-Q4',
'1997-Q1',
'1997-Q2',
'1997-Q3',
'1997-Q4',
'1998-Q1',
'1998-Q2',
'1998-Q3',
'1998-Q4',
'1999-Q1',
'1999-Q2',
'1999-Q3',
'1999-Q4',
'2000-Q1',
'2000-Q2',
'2000-Q3',
'2000-Q4',
'2001-Q1',
'2001-Q2',
'2001-Q3',
'2001-Q4',
'2002-Q1',
'2002-Q2',
'2002-Q3',
'2002-Q4',
'2003-Q1',
'2003-Q2',
'2003-Q3',
'2003-Q4',
'2004-Q1',
'2004-Q2',
'2004-Q3',
'2004-Q4',
'2005-Q1',
'2005-Q2',
'2005-Q3',
'2005-Q4',
'2006-Q1',
'2006-Q2',
'2006-Q3',
'2006-Q4',
'2007-Q1',
'2007-Q2',
'2007-Q3',
'2007-Q4',
'2008-Q1',
'2008-Q2',
'2008-Q3',
'2008-Q4',
'2009-Q1',
'2009-Q2',
'2009-Q3',
'2009-Q4',
'2010-Q1',
'2010-Q2',
'2010-Q3',
'2010-Q4',
'2011-Q1',
'2011-Q2',
'2011-Q3',
'2011-Q4',
'2012-Q1',
'2012-Q2',
'2012-Q3',
'2012-Q4',
'2013-Q1',
'2013-Q2',
'2013-Q3',
'2013-Q4',
'2014-Q1',
'2014-Q2',
'2014-Q3',
'2014-Q4',
'2015-Q1',
'2015-Q2',
'2015-Q3',
'2015-Q4',
'2016-Q1',
'2016-Q2',
'2016-Q3',
'2016-Q4',
'2017-Q1',
'2017-Q2',
'2017-Q3',
'2017-Q4',
'2018-Q1',
'2018-Q2',
'2018-Q3',
'2018-Q4',
'2019-Q1',
'2019-Q2',
'2019-Q3',
'2019-Q4',
'2020-Q1',
'2020-Q2',
'2020-Q3',
'2020-Q4',
'2021-Q1',
'2021-Q2',
'2021-Q3',
'2021-Q4',
'2022-Q1',
'2022-Q2',
'2022-Q3',
'2022-Q4',
'2023-Q1',
'2023-Q2',
'2023-Q3',
'2023-Q4',
'2024-Q1',
'2024-Q2',
'2024-Q3',
'2024-Q4',
'2025-Q1',
'2025-Q2',
'2025-Q3',
'2025-Q4',
'2026-Q1',
'2026-Q2',
'2026-Q3']

export const mhwDecadalDates = ['1985s',
'1995s',
'2005s',
'2015s',
'2025s']

// historicCRWYears, historicCRWFormatter, historicCRWToolTip, getHistoricCRWMarks, currentCRWYears, currentCRWFormatter, currentCRWToolTip, getCurrentCRWMark



export const historicCRWYears = ['2011-07-10',
'2011-07-17',
'2011-07-24',
'2011-07-31',
'2011-08-07',
'2011-08-14',
'2011-08-21',
'2011-08-28',
'2011-09-04',
'2011-09-11',
'2011-09-18',
'2011-09-25',
'2011-10-02',
'2011-10-09',
'2011-10-16',
'2011-10-23',
'2011-10-30',
'2011-11-06',
'2011-11-13',
'2011-11-20',
'2011-11-27',
'2011-12-04',
'2011-12-11',
'2011-12-18',
'2011-12-25',
'2012-01-01',
'2012-01-08',
'2012-01-15',
'2012-01-22',
'2012-01-29',
'2012-02-05',
'2012-02-12',
'2012-02-19',
'2012-02-26',
'2012-03-04',
'2012-03-11',
'2012-03-18',
'2012-03-25',
'2012-04-01',
'2012-04-08',
'2012-04-15',
'2012-04-22',
'2012-04-29',
'2012-05-06',
'2012-05-13',
'2012-05-20',
'2012-05-27',
'2012-06-03',
'2012-06-10',
'2012-06-17',
'2012-06-24',
'2012-07-01',
'2012-07-08',
'2012-07-15',
'2012-07-22',
'2012-07-29',
'2012-08-05',
'2012-08-12',
'2012-08-19',
'2012-08-26',
'2012-09-02',
'2012-09-09',
'2012-09-16',
'2012-09-23',
'2012-09-30',
'2012-10-07',
'2012-10-14',
'2012-10-21',
'2012-10-28',
'2012-11-04',
'2012-11-11',
'2012-11-18',
'2012-11-25',
'2012-12-02',
'2012-12-09',
'2012-12-16',
'2012-12-23',
'2012-12-30',
'2013-01-06',
'2013-01-13',
'2013-01-20',
'2013-01-27',
'2013-02-03',
'2013-02-10',
'2013-02-17',
'2013-02-24',
'2013-03-03',
'2013-03-10',
'2013-03-17',
'2013-03-24',
'2013-03-31',
'2013-04-07',
'2013-04-14',
'2013-04-21',
'2013-04-28',
'2013-05-05',
'2013-05-12',
'2013-05-19',
'2013-05-26',
'2013-06-02',
'2013-06-09',
'2013-06-16',
'2013-06-23',
'2013-06-30',
'2013-07-07',
'2013-07-14',
'2013-07-21',
'2013-07-28',
'2013-08-04',
'2013-08-11',
'2013-08-18',
'2013-08-25',
'2013-09-01',
'2013-09-08',
'2013-09-15',
'2013-09-22',
'2013-09-29',
'2013-10-06',
'2013-10-13',
'2013-10-20',
'2013-10-27',
'2013-11-03',
'2013-11-10',
'2013-11-17',
'2013-11-24',
'2013-12-01',
'2013-12-08',
'2013-12-15',
'2013-12-22',
'2013-12-29',
'2014-01-05',
'2014-01-12',
'2014-01-19',
'2014-01-26',
'2014-02-02',
'2014-02-09',
'2014-02-16',
'2014-02-23',
'2014-03-02',
'2014-03-09',
'2014-03-16',
'2014-03-23',
'2014-03-30',
'2014-04-06',
'2014-04-13',
'2014-04-20',
'2014-04-27',
'2014-05-04',
'2014-05-11',
'2014-05-18',
'2014-05-25',
'2014-06-01',
'2014-06-08',
'2014-06-15',
'2014-06-22',
'2014-06-29',
'2014-07-06',
'2014-07-13',
'2014-07-20',
'2014-07-27',
'2014-08-03',
'2014-08-10',
'2014-08-17',
'2014-08-24',
'2014-08-31',
'2014-09-07',
'2014-09-14',
'2014-09-21',
'2014-09-28',
'2014-10-05',
'2014-10-12',
'2014-10-19',
'2014-10-26',
'2014-11-02',
'2014-11-09',
'2014-11-16',
'2014-11-23',
'2014-11-30',
'2014-12-07',
'2014-12-14',
'2014-12-21',
'2014-12-28',
'2015-01-04',
'2015-01-11',
'2015-01-18',
'2015-01-25',
'2015-02-01',
'2015-02-08',
'2015-02-15',
'2015-02-22',
'2015-03-01',
'2015-03-08',
'2015-03-15',
'2015-03-22',
'2015-03-29',
'2015-04-05',
'2015-04-12',
'2015-04-19',
'2015-04-26',
'2015-05-03',
'2015-05-10',
'2015-05-17',
'2015-05-24',
'2015-05-31',
'2015-06-07',
'2015-06-14',
'2015-06-21',
'2015-06-28',
'2015-07-05',
'2015-07-12',
'2015-07-19',
'2015-07-26',
'2015-08-02',
'2015-08-09',
'2015-08-16',
'2015-08-23',
'2015-08-30',
'2015-09-06',
'2015-09-13',
'2015-09-20',
'2015-09-27',
'2015-10-04',
'2015-10-11',
'2015-10-18',
'2015-10-25',
'2015-11-01',
'2015-11-08',
'2015-11-15',
'2015-11-22',
'2015-11-29',
'2015-12-06',
'2015-12-13',
'2015-12-20',
'2015-12-27',
'2016-01-03',
'2016-01-10',
'2016-01-17',
'2016-01-24',
'2016-01-31',
'2016-02-07',
'2016-02-14',
'2016-02-21',
'2016-02-28',
'2016-03-06',
'2016-03-13',
'2016-03-20',
'2016-03-27',
'2016-04-03',
'2016-04-10',
'2016-04-17',
'2016-04-24',
'2016-05-01',
'2016-05-08',
'2016-05-15',
'2016-05-22',
'2016-05-29',
'2016-06-05',
'2016-06-12',
'2016-06-19',
'2016-06-26',
'2016-07-03',
'2016-07-10',
'2016-07-17',
'2016-07-24',
'2016-07-31',
'2016-08-07',
'2016-08-14',
'2016-08-21',
'2016-08-28',
'2016-09-04',
'2016-09-11',
'2016-09-18',
'2016-09-25',
'2016-10-02',
'2016-10-09',
'2016-10-16',
'2016-10-23',
'2016-10-30',
'2016-11-06',
'2016-11-13',
'2016-11-20',
'2016-11-27',
'2016-12-04',
'2016-12-11',
'2016-12-18',
'2016-12-25',
'2017-01-01',
'2017-01-08',
'2017-01-15',
'2017-01-22',
'2017-01-29',
'2017-02-05',
'2017-02-12',
'2017-02-19',
'2017-02-26',
'2017-03-05',
'2017-03-12',
'2017-03-19',
'2017-03-26',
'2017-04-02',
'2017-04-09',
'2017-04-16',
'2017-04-23',
'2017-04-30',
'2017-05-07',
'2017-05-14',
'2017-05-21',
'2017-05-28',
'2017-06-04',
'2017-06-11',
'2017-06-18',
'2017-06-25',
'2017-07-02',
'2017-07-09',
'2017-07-16',
'2017-07-23',
'2017-07-30',
'2017-08-06',
'2017-08-13',
'2017-08-20',
'2017-08-27',
'2017-09-03',
'2017-09-10',
'2017-09-17',
'2017-09-24',
'2017-10-01',
'2017-10-08',
'2017-10-15',
'2017-10-22',
'2017-10-29',
'2017-11-05',
'2017-11-12',
'2017-11-19',
'2017-11-26',
'2017-12-03',
'2017-12-10',
'2017-12-17',
'2017-12-24',
'2017-12-31',
'2018-01-07',
'2018-01-14',
'2018-01-21',
'2018-01-28',
'2018-02-04',
'2018-02-11',
'2018-02-18',
'2018-02-25',
'2018-03-04',
'2018-03-11',
'2018-03-18',
'2018-03-25',
'2018-04-01',
'2018-04-08',
'2018-04-15',
'2018-04-22',
'2018-04-29',
'2018-05-06',
'2018-05-13',
'2018-05-20',
'2018-05-27',
'2018-06-03',
'2018-06-10',
'2018-06-17',
'2018-06-24',
'2018-07-01',
'2018-07-08',
'2018-07-15',
'2018-07-22',
'2018-07-29',
'2018-08-05',
'2018-08-12',
'2018-08-19',
'2018-08-26',
'2018-09-02',
'2018-09-09',
'2018-09-16',
'2018-09-23',
'2018-09-30',
'2018-10-07',
'2018-10-14',
'2018-10-21',
'2018-10-28',
'2018-11-04',
'2018-11-11',
'2018-11-18',
'2018-11-25',
'2018-12-02',
'2018-12-09',
'2018-12-16',
'2018-12-23',
'2018-12-30',
'2019-01-06',
'2019-01-13',
'2019-01-20',
'2019-01-27',
'2019-02-03',
'2019-02-10',
'2019-02-17',
'2019-02-24',
'2019-03-03',
'2019-03-10',
'2019-03-17',
'2019-03-24',
'2019-03-31',
'2019-04-07',
'2019-04-14',
'2019-04-21',
'2019-04-28',
'2019-05-05',
'2019-05-12',
'2019-05-19',
'2019-05-26',
'2019-06-02',
'2019-06-09',
'2019-06-16',
'2019-06-23',
'2019-06-30',
'2019-07-07',
'2019-07-14',
'2019-07-21',
'2019-07-28',
'2019-08-04',
'2019-08-11',
'2019-08-18',
'2019-08-25',
'2019-09-01',
'2019-09-08',
'2019-09-15',
'2019-09-22',
'2019-09-29',
'2019-10-06',
'2019-10-13',
'2019-10-20',
'2019-10-27',
'2019-11-03',
'2019-11-10',
'2019-11-17',
'2019-11-24',
'2019-12-01',
'2019-12-08',
'2019-12-15',
'2019-12-22',
'2019-12-29',
'2020-01-05',
'2020-01-12',
'2020-01-19',
'2020-01-26',
'2020-02-02',
'2020-02-09',
'2020-02-16',
'2020-02-23',
'2020-03-01',
'2020-03-08',
'2020-03-15',
'2020-03-22',
'2020-03-29',
'2020-04-05',
'2020-04-12',
'2020-04-19',
'2020-04-26',
'2020-05-03',
'2020-05-10',
'2020-05-17',
'2020-05-24',
'2020-05-31',
'2020-06-07',
'2020-06-14',
'2020-06-21',
'2020-06-28',
'2020-07-05',
'2020-07-12',
'2020-07-19',
'2020-07-26',
'2020-08-02',
'2020-08-09',
'2020-08-16',
'2020-08-23',
'2020-08-30',
'2020-09-06',
'2020-09-13',
'2020-09-20',
'2020-09-27',
'2020-10-04',
'2020-10-11',
'2020-10-18',
'2020-10-25',
'2020-11-01',
'2020-11-08',
'2020-11-15',
'2020-11-22',
'2020-11-29',
'2020-12-06',
'2020-12-13',
'2020-12-20',
'2020-12-27',
'2021-01-03',
'2021-01-10',
'2021-01-17',
'2021-01-24',
'2021-01-31',
'2021-02-07',
'2021-02-14',
'2021-02-21',
'2021-02-28',
'2021-03-07',
'2021-03-14',
'2021-03-21',
'2021-03-28',
'2021-04-04',
'2021-04-11',
'2021-04-18',
'2021-04-25',
'2021-05-02',
'2021-05-09',
'2021-05-16',
'2021-05-23',
'2021-05-30',
'2021-06-06',
'2021-06-13',
'2021-06-20',
'2021-06-27',
'2021-07-04',
'2021-07-11',
'2021-07-18',
'2021-07-25',
'2021-08-01',
'2021-08-08',
'2021-08-15',
'2021-08-22',
'2021-08-29',
'2021-09-05',
'2021-09-12',
'2021-09-19',
'2021-09-26',
'2021-10-03',
'2021-10-10',
'2021-10-17',
'2021-10-24',
'2021-10-31',
'2021-11-07',
'2021-11-14',
'2021-11-21',
'2021-11-28',
'2021-12-05',
'2021-12-12',
'2021-12-19',
'2021-12-26',
'2022-01-02',
'2022-01-09',
'2022-01-16',
'2022-01-23',
'2022-01-30',
'2022-02-06',
'2022-02-13',
'2022-02-20',
'2022-02-27',
'2022-03-06',
'2022-03-13',
'2022-03-20',
'2022-03-27',
'2022-04-03',
'2022-04-10',
'2022-04-17',
'2022-04-24',
'2022-05-01',
'2022-05-08',
'2022-05-15',
'2022-05-22',
'2022-05-29',
'2022-06-05',
'2022-06-12',
'2022-06-19',
'2022-06-26',
'2022-07-03',
'2022-07-10',
'2022-07-17',
'2022-07-24',
'2022-07-31',
'2022-08-07',
'2022-08-14',
'2022-08-21',
'2022-08-28',
'2022-09-04',
'2022-09-11',
'2022-09-18',
'2022-09-25',
'2022-10-02',
'2022-10-09',
'2022-10-16',
'2022-10-23',
'2022-10-30',
'2022-11-06',
'2022-11-13',
'2022-11-20',
'2022-11-27',
'2022-12-04',
'2022-12-11',
'2022-12-18',
'2022-12-25',
'2023-01-01',
'2023-01-08',
'2023-01-15',
'2023-01-22',
'2023-01-29',
'2023-02-05',
'2023-02-12',
'2023-02-19',
'2023-02-26',
'2023-03-05',
'2023-03-12',
'2023-03-19',
'2023-03-26',
'2023-04-02',
'2023-04-09',
'2023-04-16',
'2023-04-23',
'2023-04-30',
'2023-05-07',
'2023-05-14',
'2023-05-21',
'2023-05-28',
'2023-06-04',
'2023-06-11',
'2023-06-18',
'2023-06-25',
'2023-07-02',
'2023-07-09',
'2023-07-16',
'2023-07-23',
'2023-07-30',
'2023-08-06',
'2023-08-13',
'2023-08-20',
'2023-08-27',
'2023-09-03',
'2023-09-10',
'2023-09-17',
'2023-09-24',
'2023-10-01',
'2023-10-08',
'2023-10-15',
'2023-10-22',
'2023-10-29',
'2023-11-05',
'2023-11-12',
'2023-11-19',
'2023-11-26',
'2023-12-03',
'2023-12-10',
'2023-12-17',
'2023-12-24',
'2023-12-31',
'2024-01-07',
'2024-01-14',
'2024-01-21',
'2024-01-28',
'2024-02-04',
'2024-02-11',
'2024-02-18',
'2024-02-25',
'2024-03-03',
'2024-03-10',
'2024-03-17',
'2024-03-24',
'2024-03-31',
'2024-04-07',
'2024-04-14',
'2024-04-21',
'2024-04-28',
'2024-05-05',
'2024-05-12',
'2024-05-19',
'2024-05-26',
'2024-06-02',
'2024-06-09',
'2024-06-16',
'2024-06-23',
'2024-06-30',
'2024-07-07',
'2024-07-14',
'2024-07-21',
'2024-07-28',
'2024-08-04',
'2024-08-11',
'2024-08-18',
'2024-08-25',
'2024-09-01',
'2024-09-08',
'2024-09-15',
'2024-09-22',
'2024-09-29',
'2024-10-06',
'2024-10-13',
'2024-10-20',
'2024-10-27',
'2024-11-03',
'2024-11-10',
'2024-11-17',
'2024-11-24',
'2024-12-01',
'2024-12-08',
'2024-12-15',
'2024-12-22',
'2024-12-29',
'2025-01-05',
'2025-01-12',
'2025-01-19',
'2025-01-26',
'2025-02-02',
'2025-02-09',
'2025-02-16',
'2025-02-23',
'2025-03-02',
'2025-03-09',
'2025-03-16',
'2025-03-23',
'2025-03-30',
'2025-04-06',
'2025-04-13',
'2025-04-20',
'2025-04-27',
'2025-05-04',
'2025-05-11',
'2025-05-18',
'2025-05-25',
'2025-06-01',
'2025-06-08',
'2025-06-15',
'2025-06-22',
'2025-06-29',
'2025-07-06',
'2025-07-13',
'2025-07-20',
'2025-07-27',
'2025-08-03',
'2025-08-10',
'2025-08-17',
'2025-08-24',
'2025-08-31',
'2025-09-07',
'2025-09-14',
'2025-09-21',
'2025-09-28',
'2025-10-05',
'2025-10-12',
'2025-10-19',
'2025-10-26',
'2025-11-02',
'2025-11-09',
'2025-11-16',
'2025-11-23',
'2025-11-30',
'2025-12-07',
'2025-12-14',
'2025-12-21',
'2025-12-28',
'2026-01-04',
'2026-01-11',
'2026-01-18',
'2026-01-25',
'2026-02-01',
'2026-02-08',
'2026-02-15',
'2026-02-22',
'2026-03-01',
'2026-03-08',
'2026-03-15',
'2026-03-22',
'2026-03-29',
'2026-04-05',
'2026-04-12',
'2026-04-19',
'2026-04-26',
'2026-05-03',
'2026-05-17',
'2026-05-24',
'2026-05-31',
'2026-06-07',
'2026-06-14',
'2026-06-21',
'2026-06-28',
'2026-07-05',
'2026-07-12',
'2026-07-19',
'2026-07-26',
'2026-08-09']

export const historicCRWFormatter = (value) => historicCRWYears[value];

export const historicCRWToolTip = {
    open: true,
    formatter: historicCRWFormatter
}

export function getHistoricCRWMarks() {
    const marksArray = historicCRWYears.map((date, index) => {
        // Check if the current index is the first or the last element.
        if (index === 0 || index === historicCRWYears.length - 1) {
            // If it is, return the mark with a visible label.
            return {
                value: index,
                label: String(date)
            };
        } else {
            // Otherwise, return the mark with a null label to hide it.
            return {
                value: index,
                label: null
            };
        }
    });

    return marksArray;
}

export function getHistoricCRWNames() {
    const names = {};
    historicCRWYears.forEach((y, i) => {
        names[i] = y;
    });
    return names;
}


export const currentCRWYears = ['2026-01-04',
'2026-01-11',
'2026-01-18',
'2026-01-25',
'2026-02-01',
'2026-02-08',
'2026-02-15',
'2026-02-22',
'2026-03-01',
'2026-03-08',
'2026-03-15',
'2026-03-22',
'2026-03-29',
'2026-04-05',
'2026-04-12',
'2026-04-19',
'2026-04-26',
'2026-05-03',
'2026-05-17',
'2026-05-24',
'2026-05-31',
'2026-06-07',
'2026-06-14',
'2026-06-21',
'2026-06-28',
'2026-07-05',
'2026-07-12',
'2026-07-19',
'2026-07-26',
'2026-08-09']

export const currentCRWFormatter = (value) => currentCRWYears[value];

export const currentCRWToolTip = {
    open: true,
    formatter: currentCRWFormatter
}

export function getCurrentCRWMarks() {
    // Map over the entire currentCRWYears array.
    const marksArray = currentCRWYears.map((date, index) => {
        // Check if the current index is the first or the last element.
        if (index === 0 || index === currentCRWYears.length - 1) {
            // If it is, return the mark with a visible label.
            return {
                value: index,
                label: String(date)
            };
        } else {
            // Otherwise, return the mark with a null label to hide it.
            return {
                value: index,
                label: null
            };
        }
    });

    return marksArray;
}

export function getCurrentCRWNames() {
    const names = {};
    currentCRWYears.forEach((y, i) => {
        names[i] = y;
    });
    return names;
}






export const regionalSeaLevelYear = [];

for (let year = 1993; year <= 2022; year++) {
    regionalSeaLevelYear.push(year);
}

// console.log(regionalSeaLevelYear);


// export function getRegionalSeaLevelMarks() {

//     const marks = {0:"1993", 29:"2022"};
//     return marks;
// }
export function getRegionalSeaLevelMarks() {
    // Original object defining the marks
    const marksObject = { 0: "1993", 29: "2022" };

    // Convert the object into the required array format [{ value: number, label: string }]
    const marksArray = Object.entries(marksObject).map(([key, label]) => ({
        value: Number(key), // Ensure the key (slider value) is a number
        label: String(label) // Ensure the label is a string
    }));

    return marksArray;
} 

export const regionalSeaLevelFormatter = (value) => {
  // Get the year from your array
  const year = regionalSeaLevelYear[value];

  // Use the modulo operator (%) to check if the year is a multiple of 5
  // If it is, return the year. Otherwise, return an empty string.
  return year % 1 === 0 ? year : '';
};

export const regionalSeaLevelToolTip = {
  open: true,
  formatter: regionalSeaLevelFormatter
};

export const APCC_PRECP_6MON_Dict ={
        0: '2024-03',
        1: '2024-04',
        2: '2024-05',
        3: '2024-06',
        4: '2024-07',
        5: '2024-08'
}

export const APCC_SST_6MON_Dict ={
    0: '2024-03',
    1: '2024-04',
    2: '2024-05',
    3: '2024-06',
    4: '2024-07',
    5: '2024-08'
}
// Helper object for the station data 
const kororStationData = {
  city: "Koror",
  coordinates: "7.33674°, 134.47686°",
  stationNumber: "GHCND:PSW00040309",
  elevation: "27.4 m"
};

const crwTechnicalDescription = (
    <div style={{ textAlign: 'justify', paddingLeft: '5px', paddingRight: '5px' }}>
        {/* <p style={{ textAlign: 'center' }}>
            <b>Heat Stress Gauge and Time Series Product Description</b>
            <br />
        </p> */}
        <p>
            The purpose of these Regional Coral Bleaching Heat Stress Gauges is to provide coral reef ecosystem managers
            with a comprehensive summary of current satellite-monitored and model-projected bleaching thermal stress conditions to help facilitate
            timely and effective management actions pertaining to mass coral bleaching.
            <br />
        </p>
        <p>
            NOAA Coral Reef Watch (CRW) has developed a set of Heat Stress Gauges to reflect the observed and forecasted
            bleaching alert level surrounding select islands or reefs. The areas chosen for monitoring are designed to match
            the 5 km Regional Virtual Station boundaries outlined in black. These gauges are based on CRW's <Link href="https://coralreefwatch.noaa.gov/product/vs/description.php#ascii" target="_blank" rel="noopener">Regional Virtual Station
            time series data</Link>, updated daily, and <Link href="https://coralreefwatch.noaa.gov/satellite/bleachingoutlook_cfs/outlook_cfs.php" target="_blank" rel="noopener">0.5-degree Climate Forecast System (CFS)-based Four-Month
            Coral Bleaching Thermal Stress Outlook</Link>, updated weekly.
            <br />
        </p>
        <p>
            CRW provides four gauges per Virtual Station that include the current near-real-time coral bleaching thermal stress
            alert level and the projected alert level for three consecutive 4-week time periods (i.e., the upcoming 1-4 weeks,
            5-8 weeks, and 9-12 weeks, hereafter referred to as 4, 8, and 12 weeks, respectively). A map of the region surrounding
            the island or coastline of interest accompanies the gauges. The image(s) show either the current 7-day maximum Bleaching
            Alert Area, the current Four-Month Coral Bleaching Outlook for 4, 8, or 12 weeks out, or a composite of the four
            depending on the user's selection. The gauge corresponding to the map is outlined in black.
            <br />
        </p>
        <p>
            Due to the regional nature of the virtual stations, the level displayed on each gauge is a derived value that is not taken from any one data point within the virtual station area.
            To derive alerts, the daily 90th percentile HotSpot values within the station boundary are used to calculate new Degree Heating Week Values unique to each Regional Virtual Station.
            From the 90th percentile HotSpot values and newly calculated DHW values, a new Bleaching Alert Area value can be calculated using the same
            <Link href="https://coralreefwatch.noaa.gov/product/5km/index_5km_baa_max_r07d.php#StressLevel" target="_blank" rel="noopener">heat stress level table</Link> as the standard 5 km Bleaching Alert Area product. 
            The daily 90th percentile HotSpot value and unique DHW and BAA values are stored in the time series data files accessible on the <Link href="https://coralreefwatch.noaa.gov/product/vs/data.php" target="_blank" rel="noopener">all stations and products page.</Link>
            This methodology keeps the Heat Stress Gauges, Time Series Graphs and Bleaching Email Alerts internally consistent and prevents a few stray warm pixels from exaggerating bleaching risk
            while reflecting the greatest thermal stress impacting the reefs in the region.
            <br />
        </p>
        <p>
            The CFS-based Outlook product used is the <Link href="https://coralreefwatch.noaa.gov/satellite/bleachingoutlook_cfs/weekly_60.php" target="_blank" rel="noopener">60% likelihood of bleaching thermal stress from the latest Four-Month
            Coral Bleaching Thermal Stress Outlook</Link>. Outlook values displayed are the maximum of a composite of each corresponding 4-week
            period (i.e., the maximum value from weeks 1-4, 5-8, or 9-12 of the Outlook). A small gray arrow is sometimes present on a gauge indicating
            a change from the previous gauge reading upon updating. If the arrow is not present then there has been no change since the last update.
            The current alert gauge and image updates daily while the outlook gauges and images update weekly.
            <br />
        </p>
        <p>
            For the current alert level, the area of interest is specified by a black outline surrounding the island(s) or known reef locations
            on the map. For the 4-, 8-, and 12-week Outlooks, the area of interest is the entire extent of the corresponding map. This
            increases the area used for the gauge level as one moves from the Bleaching Alert Area to the 4-, 8-, and 12-week Outlooks.
            The areas covered by the 8- and 12-week Outlooks increase by 2 degrees in every direction from the previous Outlook. The
            increase in area coverage as the outlook lead-time increases for the gauge calculation is designed to help coral reef managers
            understand the extent of potentially approaching offshore thermal stress, with increased projection uncertainty factored in over
            longer time scales. Incorporating an increase in the area at these predefined, projected, time-dependent spatial scales should
            capture thermal stress events that may contribute to bleaching risk at the depicted coral reefs. In some special cases (i.e, Central
            America) the extent of the outlook map may encompass two ocean basins that should not collectively be considered when determining the outlook alert.
            In these cases, a dark gray mask is drawn over the basin that is excluded when calculating the outlook alert to display on the gauges.
            <br />
        </p>
        <p>
            The time series graph provides a record of temperature, thermal stress, and bleaching potential and
            allows for comparisons between years. The SST trace shown depicts the SST value where the HotSpot value is equal to the 90th percentile HotSpot.
            The minimum and maximum SST range within the Regional Virtual Station boundary is shown as a light gray area behind the SST trace.
            Click <Link href="https://coralreefwatch.noaa.gov/product/vs/description.php" target="_blank" rel="noopener">here</Link> to access a more detailed description of the time series graphs and data.
        </p>
        <p>
            Source: <Link href="https://coralreefwatch.noaa.gov/product/vs/gauges/palau.php" target="_blank" rel="noopener">NOAA Coral Reef Watch</Link>
        </p>
    </div>
);

const crwDocEntry = {
    title: "Coral Bleaching",
    summaryContent: "Coral bleaching is a stress response of corals to environmental changes, particularly high ocean temperatures. This tool provides current conditions and outlooks for bleaching thermal stress.",
    mathSubHeader: "",
    mathContent: crwTechnicalDescription,
    mathTitle: "Technical Description"
};

const crwDailyDocEntry = {
    title: "NOAA Coral Reef Watch Daily Products",
    summaryContent: (
        <>
            Daily NOAA Coral Reef Watch v3.1 satellite products provide reef-scale context for coral heat stress: CoralTemp SST, SST Anomaly, HotSpot, Degree Heating Week (DHW), and the seven-day SST Trend.
            <br /><br />
            The map preserves NOAA CRW product units and threshold colors. The source is a daily 5 km product; Ocean Portal aggregates cells only for responsive map display.
            <br /><br />
            <Link href="https://coralreefwatch.noaa.gov/product/5km/" target="_blank" rel="noopener" className="text-cyan-400 hover:text-cyan-300 underline transition-colors">
                NOAA Coral Reef Watch daily 5 km product suite
            </Link>
        </>
    ),
    mathSubHeader: "Interpretation",
    mathContent: (
        <>
            <strong>HotSpot</strong> measures instantaneous warming above the local maximum monthly mean climatology. <strong>DHW</strong> accumulates HotSpots greater than 1 °C across the prior 12 weeks. The <strong>seven-day SST Trend</strong> describes the recent direction and rate of temperature change.
            <br /><br />
            Use the NOAA product legend on the map for the current product’s units and thresholds.
        </>
    ),
    mathTitle: "Product interpretation"
};

const oisstDocEntry = {
    title: "Optimum Interpolation SST (OISST)",
    summaryContent: (
        <>
            The NOAA 1/4° daily Optimum Interpolation Sea Surface Temperature (OISST) is an objective analysis constructed by combining observations from satellites, ships, buoys, and Argo floats on a regular global grid.
            <br /><br />
            Finalized El Niño-Southern Oscillation (ENSO) history is derived from NOAA CPC's <strong>ONI v6</strong> rolling three-month classifications. Because finalized ONI seasons lag real time, the newest months use CPC's separately identified operational advisory status.
            <br /><br />
            <Link href="https://www.ncei.noaa.gov/products/optimum-interpolation-sst" target="_blank" rel="noopener" className="text-cyan-400 hover:text-cyan-300 underline transition-colors">
                NOAA OISST Documentation
            </Link>
            <br />
            <Link href="https://www.cpc.ncep.noaa.gov/products/analysis_monitoring/enso/oni/v6/" target="_blank" rel="noopener" className="text-cyan-400 hover:text-cyan-300 underline transition-colors">
                CPC ONI v6 Table
            </Link>
            <br />
            <Link href="https://www.cpc.ncep.noaa.gov/products/analysis_monitoring/enso_advisory/ensodisc.html" target="_blank" rel="noopener" className="text-cyan-400 hover:text-cyan-300 underline transition-colors">
                CPC ENSO Diagnostic Discussion
            </Link>
            <div className="mt-5">
                <ConvergenceZoneMethodology />
            </div>
        </>
    ),
        mathSubHeader: "OISST Methodology & ONI Mathematical Formulation",
    mathContent: (
        <div className="flex flex-col gap-4 mt-2">
            <div className="bg-slate-900/50 p-4 rounded-xl border border-white/10 shadow-inner">
                    <h4 className="text-cyan-400 font-medium mb-2">1. OISST Methodology</h4>
                    <p className="text-sm text-slate-300 leading-relaxed">
                        OISST v2.1 blends observations from satellites, ships, buoys, and Argo floats into a continuous global field. Satellite and ship observations are bias-adjusted to align with more accurate in situ data from buoys and Argo floats. This methodology ensures a consistent and stable climate record over time.
                        <br /><br />
                        For full technical details, see <Link href="https://journals.ametsoc.org/view/journals/clim/34/8/JCLI-D-20-0166.1.xml" target="_blank" rel="noopener" className="text-cyan-400 hover:text-cyan-300 underline transition-colors">Huang et al. (2021)</Link>.
                </p>
            </div>

            <div className="bg-slate-900/50 p-4 rounded-xl border border-white/10 shadow-inner">
                <h4 className="text-cyan-400 font-medium mb-2">2. Oceanic Niño Index (ONI)</h4>
                <p className="text-sm text-slate-300 leading-relaxed mb-3">
                    The ONI is defined as the 3-month running mean of Sea Surface Temperature anomalies in the Niño 3.4 region (5°N-5°S, 120°-170°W):
                </p>
                <div className="font-mono text-center text-white bg-black/40 py-3 rounded-lg shadow-inner tracking-widest text-sm mb-3">
                    ONI<sub>t</sub> = <sup>1</sup>/<sub>3</sub> &sum;<sub>i = t-1</sub><sup>t+1</sup> (SST<sub>i</sub> - <span style={{textDecoration: 'overline'}}>SST</span><sub>i</sub>)
                </div>
                <p className="text-xs text-slate-400 leading-relaxed mb-3">
                    Where <span className="font-mono text-cyan-200"><span style={{textDecoration: 'overline'}}>SST</span><sub>i</sub></span> is the 30-year climatological mean for month <span className="font-mono text-cyan-200">i</span>.
                </p>
                <ul className="text-xs space-y-1.5 bg-black/20 p-3 rounded-lg border border-white/5">
                    <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-red-500"></span><strong className="text-red-400 w-16">El Niño:</strong> ONI &ge; +0.5°C</li>
                    <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-blue-500"></span><strong className="text-blue-400 w-16">La Niña:</strong> ONI &le; -0.5°C</li>
                    <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-slate-500"></span><strong className="text-slate-400 w-16">Neutral:</strong> -0.5°C &lt; ONI &lt; +0.5°C</li>
                </ul>
            </div>
        </div>
    )
};

export const documentationMap = {
  // --- Hot Days (2.2.1.3) ---
  '2.2.1.3': { 
    title: "Amount of Hot Days",
    stations: {
      city: "Koror",
      coordinates: "7.33674°, 134.47686°",
      stationNumber: "GHCND:PSW00040309",
      elevation: "27.4 m"
    },
    // SECTION 1: Summary
    summaryContent: (
      <>
        A specific calendar date for a given year is determined to be a “hot day” 
        by calculating if its maximum surface air temperature is greater than the 
        90th percentile of maximum surface air temperature for the collection of 
        five days centered on the same calendar day within the base period of 
        1961-1990. For dates that fall within the base period, a bootstrap 
        approach is used to avoid inhomogeneity. The data is obtained from the 
        Global Historical Climatology Network daily (GHCNd) Koror station.
        <br /><br />
        Further documentation about the dataset is available at{' '}
        <Link href="https://www.ncei.noaa.gov/products/land-based-station/global-historical-climatology-network-daily" target="_blank" rel="noopener">
            NCEI NOAA
        </Link>{' '}
        and further documentation about the climate index is found on{' '}
        <Link href="https://climpact-sci.org/indices/#index-TX90p" target="_blank" rel="noopener">
            Climpact Sci
        </Link>.
      </>
    ),
    // SECTION 2: Mathematical Description
    mathSubHeader: "Percentage of days when TX > 90th percentile",
    mathContent: (
      <>
        Let Txij be the daily maximum temperature on day i in period j and let 
        TXin90 be the calendar day 90th percentile centred on a 5-day window for 
        the base period 1961-1990. The percentage of time for the base period is 
        determined where TXij &gt; TXin90.
        <br /><br />
        To avoid possible inhomogeneity across the in-base and out-base periods, 
        the calculation for the base period (1961-1990) requires the use of a 
        bootstrap procedure.
      </>
    )
  },

  // --- Cold Nights (2.3.1.3) ---
  '2.3.1.3': { 
    title: "Amount of Cold Nights",
    stations: {
      city: "Koror",
      coordinates: "7.33674°, 134.47686°",
      stationNumber: "GHCND:PSW00040309",
      elevation: "27.4 m"
    },
    // SECTION 1: Summary
    summaryContent: (
      <>
        A specific calendar date for a given year is determined to be a “cold night” 
        by calculating if its minimum surface air temperature is less than the 
        10th percentile of minimum surface air temperature for the collection of 
        five days centered on the same calendar day within the base period of 
        1961-1990. For dates that fall within the base period, a bootstrap 
        approach is used to avoid inhomogeneity. The data is obtained from the 
        Global Historical Climatology Network daily (GHCNd) Koror station. The GHCNd 
        dataset contains various land surface stations data that are maintained by 
        National Centers for Environmental Information (NCEI) an organization falling 
        under the National Oceanic And Atmospheric Administration (NOAA).
        <br /><br />
        Further documentation about the dataset is available at{' '}
        <Link href="https://www.ncei.noaa.gov/products/land-based-station/global-historical-climatology-network-daily" target="_blank" rel="noopener">
            NCEI NOAA
        </Link>{' '}
        and further documentation about the climate index is found on{' '}
        <Link href="https://climpact-sci.org/indices/#index-TN10p" target="_blank" rel="noopener">
            Climpact Sci
        </Link>.
      </>
    ),

    // SECTION 2: Mathematical Description
    mathSubHeader: "Percentage of days when TN < 10th percentile",
    mathContent: (
      <>
        Let TNij be the daily minimum temperature on day i in period j and let 
        TNin10 be the calendar day 10th percentile centred on a 5-day window for 
        the base period 1961-1990. The percentage of time for the base period is 
        determined where: TNij &lt; TNin10.
        <br /><br />
        To avoid possible inhomogeneity across the in-base and out-base periods, 
        the calculation for the base period (1961-1990) requires the use of a 
        bootstrap procedure. Details are described in Zhang et al. (2005).
        <br />
        <Link href="https://climpact-sci.org/indices/#index-TN10p" target="_blank" rel="noopener">
             https://climpact-sci.org/indices/#index-TN10p
        </Link>
      </>
    )
  },
  // --- Total Wet Day Rainfall (3.1.1.3) ---
  '3.1.1.3': { 
    title: "Total Wet Day Rainfall",
    stations: kororStationData,
    
    // SECTION 1: Summary
    summaryContent: (
      <>
        The Total Wet Day Rainfall indicator is calculated by totalling the precipitation on 
        all days in a given year that is considered a “wet day” or a day where precipitation 
        is greater than 1mm. The data is obtained from the Global Historical Climatology 
        Network daily (GHCNd) Koror station. The GHCNd dataset contains various land surface 
        stations data that are maintained by National Centers for Environmental Information 
        (NCEI) an organization falling under the National Oceanic And Atmospheric Administration (NOAA).
        <br /><br />
        Further documentation about the dataset is available at{' '}
        <Link href="https://www.ncei.noaa.gov/products/land-based-station/global-historical-climatology-network-daily" target="_blank" rel="noopener">
            NCEI NOAA
        </Link>{' '}
        and further documentation about the climate index is found on{' '}
        <Link href="https://climpact-sci.org/indices/#index-PRCPTOT" target="_blank" rel="noopener">
            Climpact Sci
        </Link>.
      </>
    ),

    // SECTION 2: Mathematical Description
    mathSubHeader: "Total precipitation on wet days (> 1mm)",
    mathContent: (
      <>
        Let <i>P<sub>ij</sub></i> represent the precipitation on day <i>i</i> in year <i>j</i>, 
        and let <i>W<sub>ij</sub></i> be a binary indicator variable where <i>W<sub>ij</sub></i> = 1 
        if day <i>i</i> in year <i>j</i> is considered a "wet day" (precipitation > 1mm), 
        and 0 otherwise.
        <br /><br />
        The Total Wet Day Rainfall indicator, denoted as <i>PRCPTOT<sub>j</sub></i> for year <i>j</i>, 
        is calculated as the sum of precipitation on all wet days:
        <br /><br />
        <i>PRCPTOT<sub>j</sub></i> = &sum; <i>P<sub>ij</sub></i> &middot; <i>W<sub>ij</sub></i>
        <br /><br />
        Where <i>i</i> ranges from 1 to <i>n</i> (the total number of days in year <i>j</i>).
      </>
    )
  },

  // --- Consecutive Dry Days (3.2.1.3) ---
  '3.2.1.3': { 
    title: "Consecutive Dry Days",
    stations: kororStationData,

    // SECTION 1: Summary
    summaryContent: (
      <>
        The consecutive dry days indicator, or rather the longest consecutive dry days, is 
        calculated by determining what the longest consecutive stretch of dry days, or days 
        with less than 1.0mm of rainfall, are for a given year. The data is obtained from the 
        Global Historical Climatology Network daily (GHCNd) Koror station. The GHCNd dataset 
        contains various land surface stations data that are maintained by National Centers 
        for Environmental Information (NCEI) an organization falling under the National 
        Oceanic And Atmospheric Administration (NOAA).
        <br /><br />
        Further documentation about the dataset is available at{' '}
        <Link href="https://www.ncei.noaa.gov/products/land-based-station/global-historical-climatology-network-daily" target="_blank" rel="noopener">
             NCEI NOAA
        </Link>.
      </>
    ),

    // SECTION 2: Mathematical Description
    mathSubHeader: "Longest consecutive stretch of days < 1mm",
    mathContent: (
      <>
        Let <i>P<sub>ij</sub></i> represent the daily precipitation on day <i>i</i> in year <i>j</i>.
        <br /><br />
        The consecutive dry days indicator, denoted as <i>CDD<sub>j</sub></i> for year <i>j</i>, 
        is calculated by determining the maximum length of consecutive days where 
        precipitation <i>P<sub>ij</sub></i> &lt; 1.0mm.
        <br /><br />
        <i>CDD<sub>j</sub></i> = max(consecutive days where <i>P<sub>ij</sub></i> &lt; 1mm)
      </>
    )
  },

  // --- Heavy Rainfall (3.3.1.3) ---
  '3.3.1.3': { 
    title: "Heavy Rainfall",
    stations: kororStationData,

    // SECTION 1: Summary
    summaryContent: (
      <>
        The heavy rainfall indicator is simply the total precipitation for the day that had 
        the highest rainfall.
      </>
    ),

    // SECTION 2: Mathematical Description
    mathSubHeader: "Maximum 1-day precipitation",
    mathContent: (
      <>
        Let <i>P<sub>ij</sub></i> represent the precipitation on day <i>i</i> in year <i>j</i>.
        <br /><br />
        The heavy rainfall indicator, denoted as <i>HR<sub>j</sub></i> for year <i>j</i>, 
        is calculated by identifying the day <i>i</i> with the highest precipitation, and then 
        taking the total precipitation on that day:
        <br /><br />
        <i>HR<sub>j</sub></i> = max(<i>P<sub>ij</sub></i>)
        <br /><br />
        Where <i>n</i> represents the total number of days in year <i>j</i>, and <i>i</i> ranges from 1 to <i>n</i>.
      </>
    )
  },
  // --- OISST ---
  '7.1.2.1': oisstDocEntry,
  '7.1.2.2': oisstDocEntry,
  // --- Coral Bleaching (7.4.3.x) ---
  '7.4.3.1.1': crwDocEntry,
  '7.4.3.1.2': crwDocEntry,
  '7.4.3.1.3': crwDocEntry,
  '7.4.3.1.4': crwDocEntry,
  '7.4.3.3.1': crwDocEntry,
  '7.4.3.3.2': crwDocEntry,
  '7.4.3.3.3': crwDocEntry,
  '7.4.3.3.4': crwDocEntry,
  // --- NOAA Coral Reef Watch daily 5 km products (7.4.4.x) ---
  '7.4.4.1': crwDailyDocEntry,
  '7.4.4.2': crwDailyDocEntry,
  '7.4.4.3': crwDailyDocEntry,
  '7.4.4.4': crwDailyDocEntry,
  '7.4.4.5': crwDailyDocEntry,
  '7.4.4.6': crwDailyDocEntry,
  // Fallback for other variables
  'default': {
    title: "Variable Documentation",
    summaryContent: "Select a variable to see the summary.",
    mathSubHeader: "",
    mathContent: "No mathematical description available."
  }

};
